import { render, staticRenderFns } from "./NoticePubDetails.vue?vue&type=template&id=00b96ff0&scoped=true&"
import script from "./NoticePubDetails.vue?vue&type=script&lang=js&"
export * from "./NoticePubDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoticePubDetails.vue?vue&type=style&index=0&id=00b96ff0&scoped=true&lang=less&"
import style1 from "./NoticePubDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b96ff0",
  null
  
)

export default component.exports